/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCheckCircle16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <circle cx={8} cy={8} r={7} fill='#fff' />
      <path
        fill='#00D3A1'
        fillRule='evenodd'
        d='M16 8A8 8 0 110 8a8 8 0 0116 0zm-9 3.56l5.53-5.53-1.06-1.06L7 9.44 4.53 6.97 3.47 8.03 7 11.56z'
      />
    </svg>
  );
}

export default SvgCheckCircle16;
